import React from "react";

export const Panel = ({ title, badge, right, children, className = "", testid, bodyClass = "" }) => (
  <section className={`nx-card flex flex-col min-w-0 ${className}`} data-testid={testid}>
    <header className="flex items-center justify-between gap-2 px-4 pt-3.5 pb-2.5">
      <div className="flex items-center gap-2 min-w-0">
        <h2 className="font-display text-[15px] font-semibold text-white truncate">{title}</h2>
        {badge != null && <span className="px-1.5 py-0.5 rounded-md text-[10px] font-bold bg-[#1B2A44] text-sky-300 border border-sky-500/20">{badge}</span>}
      </div>
      {right}
    </header>
    <div className={`flex-1 min-h-0 ${bodyClass}`}>{children}</div>
  </section>
);

export const GhostBtn = ({ children, onClick, testid, className = "" }) => (
  <button type="button" onClick={onClick} data-testid={testid}
    className={`px-3 h-8 rounded-lg border border-white/12 bg-white/[0.03] text-[12px] text-slate-200 hover:border-[#D4A72C]/50 hover:text-white transition-colors whitespace-nowrap ${className}`}>{children}</button>
);

export const Delta = ({ cur, prev, suffix = "%", points = false }) => {
  if (cur == null || prev == null || (!points && !prev)) return null;
  const v = points ? Math.round((cur - prev) * 10) / 10 : Math.round(((cur - prev) / prev) * 100);
  return <span className={`text-sm font-semibold ${v >= 0 ? "text-emerald-400" : "text-rose-400"}`}>{v >= 0 ? "+" : ""}{v}{points ? " pt" : suffix}</span>;
};

export const STATUS_TONE = {
  Completata: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  "In corso": "bg-sky-500/15 text-sky-300 border-sky-500/30",
  Assegnata: "bg-teal-500/15 text-teal-300 border-teal-500/30",
  Confermata: "bg-teal-500/15 text-teal-300 border-teal-500/30",
  "No show": "bg-rose-500/15 text-rose-300 border-rose-500/30",
};
export const statusBar = (s, unassigned) => unassigned ? "bg-rose-500" : s === "Completata" ? "bg-emerald-500" : s === "In corso" ? "bg-sky-400" : "bg-[#D4A72C]";
